module.exports = __webpack_public_path__ + "img/gift_top-purple_gift.e53fdfb7.png";